import React from 'react';
import PropTypes from 'prop-types'

import { isAuthenticated, isAuthorizedRole } from "./AppSecurity";
import {HomeView} from '../components/home/HomeView';
import CreateCandidate from '../components/nyscandidate/CandidateDetailsView';

export const ToggleHomeView = () => (isAuthenticated())
    ? <CreateCandidate />
    : <HomeView />
;

export const RenderAuthenticated = ({ children }) =>
    (isAuthenticated()) ? children : null
;

export const RenderAnonymous = ({ children }) => 
    (!isAuthenticated()) ? children : null;

export const RenderByRole = ({ roles, children }) =>
    (isAuthorizedRole(roles) ? children : null)
;

RenderByRole.propTypes = {
    roles: PropTypes.arrayOf(PropTypes.string).isRequired,
}
